module.exports = __webpack_public_path__ + "static/media/img80.0e5255bb.jpg";